import { Box } from "@mui/material";
import theme from "src/theme/light";
import { LayoutProps, Layout } from "../../_layouts";
import { PremissasText } from "../../_layouts/containers/Premissa";
import { GradientButton } from "src/framework/components/buttons/GradientButton";
import { GraficosRoiPayback } from "../../containers/GraficosRoiPayback";

interface LayoutProjetoKitProps extends LayoutProps {
  mostrarPremissas?: boolean
}

const LayoutProjetoKit: React.FC<LayoutProjetoKitProps> = ({children, mostrarPremissas = true, ...props}) => {
  return (
    <>
      <Layout {...props}>
        <>
          {children}

          {mostrarPremissas && (
            <Box p={2}>
              <Box borderRadius="8px" p={2} width='100%' height={"auto"} bgcolor={theme.palette.grey[200]}>
                <PremissasText />
                <GradientButton label="#InformaçõesProjetos" />
              </Box>
            </Box>
          )}
        </>
      </Layout>
      <GraficosRoiPayback 
        valor_servico={props?.formState?.valor_servico || 0}
      />
    </>
  );
}


export { LayoutProjetoKit }